module.exports = __webpack_public_path__ + "static/1-c550d7da5fa35428d85b2097102d78ea.png";